import { signalsRoutingParamsToClear } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";

function updateTrackingQueryParams() {
    setTimeout(() => {
        proNavigator.updateQueryParams(signalsRoutingParamsToClear, {
            reload: false,
            replace: true,
        });
    });
}

export default updateTrackingQueryParams;
